import { Theme, createStyles, withStyles, WithStyles } from '@material-ui/core';
import { colors } from '../../../styles/theme';
import { MOBILE_BREAKPOINT } from '../../../utils/utilityHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { useContext, useMemo } from 'react';
import { LanguageContext } from '../../../contexts/LanguageContext/languageContext';

interface InfoSectionProps extends WithStyles<typeof styles> {
  isLoadingData: boolean;
  numberOfFilters: number;
  numberOfElements?: number;
  numberOfVisible?: number;
  handleFilterReset: () => void;
}

const InfoSection = ({
  classes,
  numberOfFilters,
  numberOfElements,
  numberOfVisible,
  handleFilterReset,
}: InfoSectionProps) => {
  const { translate } = useContext(LanguageContext);

  const showVisibleElements = useMemo(() => {
    return numberOfVisible !== undefined ? true : false;
  }, [numberOfElements, numberOfVisible]);

  return (
    <div className={classes.showingSection}>
      {!!numberOfFilters && (
        <div className={classes.activeFilterSection}>
          <FontAwesomeIcon icon={faCircleInfo} className={classes.info} />
          {`${translate('ACTIVE FILTERS ($__FILTERS__$)', { FILTERS: numberOfFilters })}${
            showVisibleElements ? ':' : ''
          }`}
          {showVisibleElements && (
            <span className={classes.showingTxt}>{` ${translate('Showing')}
          ${numberOfVisible} ${translate('of')} ${numberOfElements}`}</span>
          )}
        </div>
      )}
      {numberOfFilters ? (
        <span className={classes.clearFilters} onClick={handleFilterReset}>
          <> {translate('Clear All')}</>
        </span>
      ) : (
        ''
      )}
    </div>
  );
};

const styles = (theme: Theme) =>
  createStyles({
    showingSection: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: 20,
      whiteSpace: 'nowrap',
      [theme.breakpoints.down(MOBILE_BREAKPOINT + 1)]: {
        paddingLeft: 0,
        paddingBottom: 10,
      },
    },
    info: {
      width: 20,
      height: 20,
      color: theme.palette.primary.main,
    },
    activeFilterSection: {
      display: 'flex',
      alignItems: 'center',
      gap: 5,
      fontWeight: 500,
      fontSize: 14,
      fontStyle: 'normal',
      fontFamily: 'Roboto',
      color: colors.black0,
    },
    showingTxt: {
      fontWeight: 400,
    },
    progressSpinnerSection: {
      marginLeft: 5,
      marginRight: 5,
      marginTop: 3,
    },
    filterNumberSpan: {
      color: colors.danger,
    },
    clearFilters: {
      color: theme.palette.primary.main,
      fontWeight: 500,
      fontSize: 13,
      fontStyle: 'normal',
      fontFamily: 'Roboto',
      marginLeft: 10,
      border: `1px solid ${theme.palette.primary.main}`,
      padding: '6px 10px',
      borderRadius: 4,
      '&:hover': {
        cursor: 'pointer',
      },
    },
  });

export default withStyles(styles)(InfoSection);
